import React from 'react';
import PropTypes from 'prop-types';

import { NumberInput } from 'ui-components/components/number-input';
import { noop } from 'ui-components/default-props/noop';

import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const ServiceCountSection = ({ isDisabled = false, onChange = noop, serviceCounts = emptyArray }) => {
  return serviceCounts.map((service) => {
    return (
      <React.Fragment key={service.key}>
        <div className={`${isDisabled ? style['static-label'] : style.label}`}>{service.name}</div>
        <div key={service.key} className={style['num-input']}>
          {isDisabled ? (
            <span className={style.static}>{service.count}</span>
          ) : (
            <NumberInput min={0} onChange={onChange(service.key)} value={service.count} />
          )}
        </div>
      </React.Fragment>
    );
  });
};

ServiceCountSection.propTypes = {
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  serviceCounts: PropTypes.array,
};

export default ServiceCountSection;
